export const getItemFromId = (list, id) => {
    let trueItem = {}
    list.forEach((item) => {
        if (item.id === id) {
            trueItem = { ...item }
        }
    })
    return trueItem
}
